/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksarchive2Inputs */

const en_downloadlinksarchive2 = /** @type {(inputs: Downloadlinksarchive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

const de_downloadlinksarchive2 = /** @type {(inputs: Downloadlinksarchive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivieren`)
};

/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Downloadlinksarchive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksarchive2 = /** @type {((inputs?: Downloadlinksarchive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksarchive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksarchive2(inputs)
	return de_downloadlinksarchive2(inputs)
});
export { downloadlinksarchive2 as "downloadLinksArchive" }